import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";

const useRoleListing = () => {
  const { authData } = useSelector((state) => state.loginSlice);

  const [roles, setRoles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [debouncedTerm, setDebouncedTerm] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [rolesPerPage, setRolesPerPage] = useState(10);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
    let value = e.target.value;

    if (value.startsWith(" ")) return;
    const isValid = /^[a-zA-Z0-9 ]*$/.test(value);

    if (!isValid) {
      return;
    }
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handlePageSizeChange = (e) => {
    setRolesPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  const fetchRoles = async () => {
    try {
      setLoader(true);
      let url = `${endpoint.GET_ROLES}?pageNumber=${currentPage}&pageSize=${rolesPerPage}`;
      if (searchTerm) {
        url += `&search=${searchTerm}`;
      }
      const response = await apiHandler({
        url: url,
        method: "GET",
        authToken: authData,
        dispatch,
      });

      if (response.data.success) {
        const roles = response?.data?.data?.roles;
        setRoles(roles);
        setTotalCount(response.data.data?.totalCount);
      }
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedTerm(searchTerm);
    }, 500); // Debounce delay (500ms)

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  useEffect(() => {
    fetchRoles();
  }, [currentPage, rolesPerPage, debouncedTerm]);

  return {
    handlePageClick,
    handlePageSizeChange,
    handleSearch,
    roles,
    totalCount,
    searchTerm,
    rolesPerPage,
    currentPage,
    loader,
  };
};

export default useRoleListing;
